<template>
  <div class="data">
    <span class="count">{{ total }}</span>
    <span class="title">{{ label }}</span>
    <div class="count-progress">
      <span class="number">{{ progress }}</span>
      <span class="label"> % {{ $t('dashboard.period.' + period) }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProgressIndicator',
  props: {
    total: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      required: true
    },
    previousValue: {
      type: Number,
      default: 0
    },
    period: {
      type: String,
      required: true
    }
  },
  computed: {
    progress() {
      if (this.previousValue > 0) {
        let ratio = (this.total - this.previousValue) / this.previousValue
        let result = (ratio * 100).toFixed(1)
        return result >= 0 ? `+ ${result}` : result
      }
      return 0
    }
  }
}

</script>

<style scoped lang="scss">

.data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .title {
    font-size: 30px;
    text-transform: capitalize;
  }

  .count {
    color: $primary-color;
    font-size: 83px;
    font-weight: 400;
    height: 113px;
  }

  .count-progress {
    .number {
      font-size: 28px;
    }

    .label {
      font-size: 18px;
    }
  }
}

</style>
